module.exports = __webpack_public_path__ + "img/mobile_platform_top_img.3d2f4c3b.png";